import { FC } from "react";
import styles from "./OrganizationLegend.module.sass";
import cn from "classnames";

export const OrganizationLegend: FC = () => {
	const legendList = [
		{ type: "main", name: "Головная организация" },
		{ type: "subsidiary", name: "Дочерняя организация" },
		{ type: "branch", name: "Филиал" },
		{ type: "division", name: "Обособленное подразделение" },
	];

	return (
		<div data-comment-false={true} className={styles.legend}>
			<span className={styles["legend-title"]}>Легенда:</span>
			{legendList.map((item, i) => (
				<div key={i} className={styles["legend-item"]}>
					<div className={cn(styles["legend-item-sign"], styles[`legend-item-sign-${item.type}`])}></div>
					<span className={styles["legend-item-txt"]}>{item.name}</span>
				</div>
			))}
		</div>
	);
};
